import { useState, useEffect } from "react";
import CampaignTable from "./Campaigns/CampaignTable";
import CreateCampaignModal from "./Campaigns/CreateCampaignModal";
import Overview from "./Overview";
import CampaignSelectionModal from "./Campaigns/CampaignSelectionModal";
import ScheduleCampaign from "./Campaigns/ScheduleCampaign";
import { ToastContainer } from "react-toastify";
import { useCampaigns } from "../../context/CampaignContext";
import CampaignStats from "./Campaigns/CampaignStats";
import { useTimeRange } from "../../context/TimeRangeContext";

export default function Campaigns() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [campaignType, setCampaignType] = useState("");
  const [statsData, setStatsData] = useState({
    delivered: { total: 0, change: { percentage_change: 0, type: "No change" } },
    opened: { total: 0, change: { percentage_change: 0, type: "No change" } },
    clicked: { total: 0, change: { percentage_change: 0, type: "No change" } },
    bounced: { total: 0, change: { percentage_change: 0, type: "No change" } },
  });
  

  const { timeRange } = useTimeRange();
  const {
    paginatedCampaigns,
    currentPage,
    setCurrentPage,
    totalPages,
    fetchPaginatedCampaigns,
    fetchAllCampaigns,
  } = useCampaigns();

  useEffect(() => {
    console.log("Selected Campaign Type:", campaignType);
  }, [campaignType]);

  // Fetch campaign analytics data
  useEffect(() => {
    const fetchStats = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch("https://zola.technology/api/company/campaigns/analytics/", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await response.json();
  
        if (response.ok) {
          setStatsData({
            delivered: data.total_delivered,
            opened: data.total_opened,
            clicked: data.total_clicked,
            bounced: data.total_bounced,
          });
        } else {
          console.error("Failed to fetch campaign stats:", data);
        }
      } catch (error) {
        console.error("Error fetching campaign stats:", error);
      }
    };
  
    fetchStats();
  }, []);
  

  const refetchCampaigns = () => {
    fetchPaginatedCampaigns();
    fetchAllCampaigns();
  };

  return (
    <div className="grid gap-8">
      <ToastContainer position="top-right" autoClose={3000} />

      <Overview
        title="Campaigns"
        showCreateCampaignButton={true}
        showExportButton={false}
        hideTimeRange={true}
        onCreateCampaignClick={() => setShowModal(true)}
      />

      {/* Stats */}
      <CampaignStats statsData={statsData} />

      <div className="grid grid-cols-12 gap-6">
        <CampaignTable
          className="col-span-12 lg:col-span-8"
          campaigns={paginatedCampaigns.map((campaign) => ({
            id: campaign.id,
            name: campaign.name,
            subject: campaign.subject,
            message: campaign.message,
            date: new Date(campaign.scheduled_at).toLocaleString(),
            scheduled_at: campaign.scheduled_at,
            delivered: campaign.contacts.length,
            clicked: 0,
            status: campaign.status === "sent" ? "Completed" : "Pending",
          }))}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
          refetchCampaigns={refetchCampaigns}
        />
        <ScheduleCampaign className="col-span-12 lg:col-span-4" />
      </div>

      {isModalOpen && (
        <CreateCampaignModal
          onClose={() => setIsModalOpen(false)}
          campaignType={campaignType}
          refetchCampaigns={refetchCampaigns}
        />
      )}

      {showModal && (
        <CampaignSelectionModal
          onClose={() => setShowModal(false)}
          onSelect={(type) => {
            setCampaignType(type);
            setIsModalOpen(true);
          }}
        />
      )}
    </div>
  );
}
